import { useCallback } from 'react';
import {
  ErrorVariants,
  FieldOpsCustomerListData,
  clearSelectedItemIds,
  dispatch,
  getWorkspaceId,
  showToast,
  updateCatalogDownloadStatus,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { SortDirection } from '../../constants';
import { useCustomerProfileFetcher } from './use-customer-profile-fetcher';
export const useCatalogDownlaodForCustomer = () => {
  const sellerWorkspaceId = useAppSelector(getWorkspaceId);

  const { fetchCatalogListLowPriority } = useCustomerProfileFetcher();

  const handleGetAllDataApi = (
    pageNo: number = 0,
    totalCount: number | undefined = undefined,
    endRecord: number | undefined = undefined,
    customerId: string,
    promiseList: Promise<void>[] = []
  ) => {
    if (
      (totalCount && endRecord && totalCount === endRecord) ||
      totalCount === 0
    ) {
      dispatch(updateCatalogDownloadStatus({ customerId, status: true }));
      return;
    }
    const payload = {
      workspaceId: sellerWorkspaceId,
      params: {
        customerId: customerId,
        pageNo: pageNo,
        pageSize: 200,
      },
      body: {
        sortBy: 'sortOrder',
        sortDirection: SortDirection.ASCENDING,
        customerId: customerId,
        includeCategoryTreeList: true,
      },
    };
    promiseList.push(
      fetchCatalogListLowPriority(payload)
        ?.then((res) => {
          if (res?.total && res?.endRecord) {
            handleGetAllDataApi(
              pageNo + 1,
              res?.total,
              res?.endRecord,
              customerId,
              promiseList
            );
          }
        })
        .catch((err) => {
          console.error(
            'error in downloading catalog for customer : ',
            customerId
          );
        })
    );
  };

  const downloadCatalogForCustomers = useCallback(
    ({
      customerIds = [],
      setShowCheckboxes = () => {},
      selectedTab = undefined,
      fieldOpsCustomer = undefined,
      totalCustomers = 0,
    }: {
      customerIds?: string[];
      setShowCheckboxes?: (val: boolean) => void;
      selectedTab?: number;
      fieldOpsCustomer?: FieldOpsCustomerListData[];
      totalCustomers?: number;
    }) => {
      let customerToDownloadCatalogsFor:
        | string[]
        | FieldOpsCustomerListData[]
        | undefined;
      if (!customerIds) {
        customerToDownloadCatalogsFor = fieldOpsCustomer || [];
      } else {
        customerToDownloadCatalogsFor = customerIds;
      }
      if (
        (selectedTab && selectedTab === 0) ||
        (!customerIds &&
          totalCustomers &&
          totalCustomers === customerToDownloadCatalogsFor?.length) ||
        customerIds
      ) {
        setShowCheckboxes?.(false);
        dispatch(clearSelectedItemIds());
        const catalogApiCalls: Promise<void>[] = [];
        customerToDownloadCatalogsFor?.forEach((customer) => {
          const customerId =
            typeof customer === 'string' ? customer : customer?.id;
          handleGetAllDataApi(
            1,
            undefined,
            undefined,
            customerId,
            catalogApiCalls
          );
        });
        Promise.all(catalogApiCalls)?.then((res) => {
          dispatch(
            showToast({
              message: 'Products Downloaded Successfully',
              type: ErrorVariants.SUCCESS,
              canDisplay: true,
              responseStatus: 'Success',
            })
          );
        });
      }
    },
    []
  );

  return { downloadCatalogForCustomers, handleGetAllDataApi };
};
